import { render, staticRenderFns } from "./ExchangeRateDisplayDialog.vue?vue&type=template&id=6007b828"
import script from "./ExchangeRateDisplayDialog.vue?vue&type=script&lang=js"
export * from "./ExchangeRateDisplayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports